// src/components/Banner.tsx

import React, { useEffect, useState } from 'react';
import '../css/Banner.css';
// Import images directly
import slide1 from '../assets/images/banner1.jpg';
import slide2 from '../assets/images/banner2.jpg';
import slide3 from '../assets/images/banner3.jpg';
import slide4 from '../assets/images/banner4.jpg';
import slide5 from '../assets/images/banner5.jpg';
//import slide6 from '../assets/images/banner11.jpg';
//import slide7 from '../assets/images/banner12.jpg';
//import slide8 from '../assets/images/banner13.jpg';
//import slide9 from '../assets/images/banner14.jpg';
const Banner: React.FC = () => {
  // Initialize the slide index (current slide)
  const [currentSlide, setCurrentSlide] = useState(0);

  // Array of image paths (relative to the public directory)
  const slides = [
    slide1, slide2, slide3, slide4, slide5,
    //slide6, slide7,slide8, slide9
  ];
   // Next slide function
   const nextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
  };

  // Previous slide function
  const prevSlide = () => {
    setCurrentSlide(
      (prevSlide) => (prevSlide - 1 + slides.length) % slides.length
    );
  };
  // Auto slide every 3 seconds
  useEffect(() => {
    const interval = setInterval(nextSlide, 3000);
    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);

  return (
    <div className="banner-container">
      <div
        className="banner-slides"
        style={{ transform: `translateX(-${currentSlide * 100}%)` }}
      >
        {/* Loop through slides and render each one */}
        {slides.map((slide, index) => (
          <div className="banner-slide" key={index}>
            <img src={slide} alt={`Slide ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Navigation Buttons */}
      <button className="prev" onClick={prevSlide}>
        &#10094;
      </button>
      <button className="next" onClick={nextSlide}>
        &#10095;
      </button>
      </div>
      );
};

export default Banner;
